/**
 * Klaviyo back in stock button: keep it next to the main Add to cart button.
 *
 * Klaviyo's onsite script adds its "Notify me when available" button to the LAST product form on the page.
 * On our product pages that is not the main one: on alpaknitwear.com it is the sticky Add to cart bar
 * (hidden on desktop), on alpapro.com a product card in the complementary products carousel (hidden).
 * Klaviyo has no setting for which button it uses, so this script moves Klaviyo's button into the main
 * product form's buy buttons, right under the Sold out button, every time Klaviyo adds or re-adds it.
 *
 * Nothing here changes what Klaviyo does after a click: the form, the list and the flow stay in Klaviyo.
 */
(() => {
  const CONTAINER_ID = 'klaviyo-bis-button-container';

  const mainBuyButtons = () => {
    const picker = document.querySelector('variant-picker[context="main_product"]');
    const formId = picker?.getAttribute('form-id');
    const candidates = [...document.querySelectorAll('buy-buttons')].filter(
      (element) => !element.closest('product-sticky-bar') && (!formId || element.getAttribute('form') === formId)
    );
    return candidates[0] || null;
  };

  const place = () => {
    const container = document.getElementById(CONTAINER_ID);
    const target = mainBuyButtons();
    if (!container || !target || target.contains(container)) return;

    const button = target.querySelector('button[type="submit"]');
    if (button) {
      button.insertAdjacentElement('afterend', container);
    } else {
      target.appendChild(container);
    }
  };

  const observer = new MutationObserver(place);
  const start = () => {
    place();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
